export default {
  label: 'Namn',
  error: 'Ange ditt namn'
}
